import {
  WalkingDog,
  WalkingDog2,
  WalkingDog3,
  WalkingFlamingo,
  WalkingPencil,
} from "../../assets/exports/FileExports";

const ImageRandomizer = () => {

  const images = [
    WalkingDog,
    WalkingDog2,
    WalkingDog3,
    WalkingFlamingo,
    WalkingPencil,
  ];
  const randomIndex = Math.floor(Math.random() * images.length);
  return images[randomIndex];
};

export default ImageRandomizer;
